import { useQuery } from '@tanstack/react-query'

import type { UseQueryResult } from '@tanstack/react-query'
import type { IPlacement } from '~/types/placements'

import { getPlacements } from '~/api/placements'

////////// KEYS //////////
export const placementsKeys = {
  all: ['placements-all'] as const,
  list: (appKey?: string, key?: string, page?: number, size?: number) =>
    [...placementsKeys.all, 'list', appKey, key, page, size] as const,
}

////////// QUERIES //////////
export const usePlacementsQuery = ({
  appKey,
  key,
  page,
  size,
}: {
  appKey?: string
  key?: string
  page?: number
  size?: number
}): UseQueryResult<IPaginatedResponse<IPlacement>> => {
  return useQuery({
    queryFn: () => getPlacements({ appKey, key, page, size }),
    queryKey: placementsKeys.list(appKey, key, page, size),
  })
}
